import React, { useState, useMemo } from 'react';
import { Select, Spin } from 'antd';

import BookCard from '../../../components/shared/BookCard';
import SectionTitle from '../../../components/shared/SectionTitle';
import EmptyState from '../../../components/shared/EmptyState';
import { useApi } from '../../../hooks/useApi';

import { Section, InventoryHeader, BooksGrid } from '../styles';

const SORT_OPTIONS = [
  { value: 'price-asc', label: 'Precio: menor a mayor' },
  { value: 'price-desc', label: 'Precio: mayor a menor' },
  { value: 'alpha-az', label: 'Alfabético A-Z' },
  { value: 'recent', label: 'Más recientes' },
];

function sortBooks(books, sortKey) {
  const sorted = [...books];

  switch (sortKey) {
    case 'price-asc':
      return sorted.sort((a, b) => a.price - b.price);
    case 'price-desc':
      return sorted.sort((a, b) => b.price - a.price);
    case 'alpha-az':
      return sorted.sort((a, b) => a.title.localeCompare(b.title, 'es'));
    case 'recent':
      return sorted.reverse();
    default:
      return sorted;
  }
}

export default function FullInventory({ sellerId }) {
  const [sortKey, setSortKey] = useState('recent');
  const { data: allBooks, loading } = useApi(`/sellers/${sellerId}/books`);

  const sortedBooks = useMemo(
    () => sortBooks(allBooks || [], sortKey),
    [allBooks, sortKey],
  );

  return (
    <Section>
      <InventoryHeader>
        <SectionTitle title="Todos los productos" />
        <Select
          value={sortKey}
          onChange={setSortKey}
          options={SORT_OPTIONS}
          style={{ width: 240 }}
        />
      </InventoryHeader>

      {loading ? (
        <Spin size="large" style={{ display: 'block', margin: '40px auto' }} />
      ) : sortedBooks.length === 0 ? (
        <EmptyState description="Este vendedor aún no tiene productos" />
      ) : (
        <BooksGrid>
          {sortedBooks.map((book) => (
            <BookCard
              key={book.id}
              id={book.id}
              title={book.title}
              author={book.authorName}
              price={book.price}
              originalPrice={book.originalPrice}
              condition={book.condition}
              coverImage={book.coverImage}
              showAddToCart
            />
          ))}
        </BooksGrid>
      )}
    </Section>
  );
}
